
window._ = require('lodash');
window.Popper = require('popper.js').default;

require('leaflet');
require('leaflet-defaulticon-compatibility');
require('leaflet-routing-machine');
require('@geoman-io/leaflet-geoman-free');
require('@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css');
require('leaflet.motion/dist/leaflet.motion.js');
require('leaflet.fullscreen');
require('leaflet.awesome-markers');

// Keep geoman-io/leaflet-geoman-free off unless we ask for it
L.PM.setOptIn(true);

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.$ = window.jQuery = require('jquery');
    require('bootstrap');
} catch (e) {}

import 'jquery-ui/ui/widgets/dialog.js';

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
window.io = require('socket.io-client');

window.Echo = new Echo({
    broadcaster: process.env.MIX_WEBSOCKET_BROADCASTER,
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    encrypted: process.env.MIX_PUSHER_APP_ENCRYPTED,


    forceTLS: process.env.MIX_WEBSOCKET_FORCE_TLS,

    encrypted: process.env.MIX_WEBSOCKET_FORCE_ENCRYPTED,
    host: process.env.MIX_WEBSOCKET_HOST,
});
